import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '600px',
  backgroundColor: theme.palette.common.white,
  padding: '15px',
  borderRadius: theme.shape.customBorderRadius.main,
  '&:focus': {
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
  },
}))

export const LgStyledBox = styled(StyledBox)({
  width: '100%',
})

export const ModalHeaderWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  svg: {
    color: theme.palette.text.secondary,
    fontSize: 'x-large',
    cursor: 'pointer',
  },
}))

export const ModalHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '7px',
  h4: {
    fontSize: '20px',
    fontWeight: '500',
    color: theme.palette.text.primary, //'#0F1222'
  },
}))

export const ModalBody = styled('div')({
  margin: '15px 0px',
})
